export default __webpack_public_path__ + "static/media/mrle-vchod.d546609c.jpg";